export const environment = {
  production: false,
  apiBaseUrl: 'https://7gx12p96i3.execute-api.ap-south-1.amazonaws.com/dev',
};
